class Module {
	constructor(el) {
		this.el = el
	}
}

export const initModule = () => {
	document.querySelectorAll('.module').forEach(el => {
		new Module(el)
	})
}

export default () => {} 